import moment from "moment";

// Filter mapping for URL query params
export const getQueryFilterMap = (query) => {
  const filterMap = {
    "todays-documents-due-date": {
      document_due_date_from: moment().format("YYYY-MM-DD"),
      document_due_date_to: moment().format("YYYY-MM-DD"),
    },
    "todays-embassy-due-date": {
      embassy_due_date_from: moment().format("YYYY-MM-DD"),
      embassy_due_date_to: moment().format("YYYY-MM-DD"),
    },
    "todays-follow-up-date": {
      followup_date_from: moment().format("YYYY-MM-DD"),
      followup_date_to: moment().format("YYYY-MM-DD"),
    },
  };
  return filterMap[query] || null;
};
